/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLoopRight2 = createReactComponent("outline", "arrow-loop-right-2", "IconArrowLoopRight2", [["path", { "d": "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13", "key": "svg-0" }], ["path", { "d": "M17 16l4 -4l-4 -4", "key": "svg-1" }]]);

export { IconArrowLoopRight2 as default };
//# sourceMappingURL=IconArrowLoopRight2.mjs.map
